// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[600]
        },
        outlined: {
          lineHeight: '1rem',
          top: -4,
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1em'
          },
          '&.MuiInputLabel-shrink': {
            // Nutná pro čitelnost, ne jen kosmetická (2026-08-29, real bug
            // fixed) - MUI vestavěný "zářez" v rámečku (fieldset/legend) má
            // natvrdo padding 5px kolem měřicího textu, kdežto viditelný
            // label má vlastní širší padding 8px (viz níže) - bez pozadí tak
            // linka rámečku neprochází přesně pod maskovaným textem a
            // viditelně ho "přeříznout" uprostřed. Musí sedět s pozadím
            // Dialogu/Draweru (viz themes/overrides/Dialog.js, Drawer.js -
            // obojí `backgroundImage: 'none'`), jinak by patch samotný
            // vytvářel viditelnou skvrnu jiné barvy.
            background: theme.vars.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6,
            top: 2,
            // 1.5rem, ne 1rem (real bug fixed, 2026-08-29) - shrink label má
            // font-size 19.2px (1.2rem, před scale(0.75) transformem), ale
            // MuiInputLabel-root defaultně `overflow: hidden` - line-height
            // menší než font-size (1rem = 16px < 19.2px) osekával horní část
            // písmen (viz "Od"/"Důvod" nahoře ořezané).
            lineHeight: '1.5rem'
          }
        }
      }
    }
  };
}
